<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-chip-group active-class="primary--text" column>
						<v-chip v-for="(favorit, index) in favorits" :key="index" 
							close
							@click:close="removeFavorit(favorit)"
							@click="onFavorit(favorit)"
						>
						{{ favorit.name }}
						</v-chip>
					</v-chip-group>
					<!-- <z-vehicle-parameters  ref="parameters" yearProdPeriod></z-vehicle-parameters> -->
					<z-vehicle-parameters  ref="parameters"></z-vehicle-parameters>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- <v-list-item :to="{name: `Help${$options.name}`}"> -->
				<v-list-item :href="`https://ortica-systems.com/tutorial/api/VehicleEstimateDealer.html`" target="_blank">
				<!-- <v-list-item :href="`/tutorial/api/${$options.name}.html`" target="_blank"> -->
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="blue" v-bind="attrs" v-on="{ ...tooltip }" >mdi-help</v-icon>
							</template>
							<span>Інструкція</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="text-h5">{{ title }} {{ id ? '№' + id: '' }}</v-card-title>
				<v-card-subtitle class="font-weight-light">{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<v-card-text v-for="(estimate, index) in estimates" :key="index">
					<v-card flat>
						<v-card-title>Оцінка</v-card-title>
						<v-simple-table dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th>Назва</th>
										<th class="text-right">UAH</th>
										<th class="text-right">USD</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Мінімальна ціна</td>
										<td class="text-right">{{ isNaN(parseInt(estimate.minPriceUAH)) ? '' : parseInt(estimate.minPriceUAH) | toMoney }}</td>
										<td class="text-right">{{ isNaN(parseInt(estimate.minPriceUSD)) ? '' : parseInt(estimate.minPriceUSD) | toMoney }}</td>
									</tr>
									<tr>
										<td>Максимальна ціна</td>
										<td class="text-right">{{ isNaN(parseInt(estimate.maxPriceUAH)) ? '' : parseInt(estimate.maxPriceUAH) | toMoney }}</td>
										<td class="text-right">{{ isNaN(parseInt(estimate.maxPriceUSD)) ? '' : parseInt(estimate.maxPriceUSD) | toMoney }}</td>
									</tr>
									<tr>
										<td>Середня ціна</td>
										<td class="text-right">{{ isNaN(parseInt(estimate.avgPriceUAH)) ? '' : parseInt(estimate.avgPriceUAH) | toMoney }}</td>
										<td class="text-right">{{ isNaN(parseInt(estimate.avgPriceUSD)) ? '' : parseInt(estimate.avgPriceUSD) | toMoney }}</td>
									</tr>
									<!-- <tr>
										<td>Загальна кількість оголошень, що беруть участь у підрахунку</td>
										<td>{{ estimate.total }}</td>
									</tr> -->
								</tbody>
							</template>
						</v-simple-table>
					</v-card>
					<v-card flat>
						<v-card-title>Ціни</v-card-title>
						<v-data-table v-if="estimate.adverts.length"
							:headers="headers"
							:items="estimate.adverts"
							hide-default-footer
							disable-pagination
						>
							<template v-slot:item.priceUAH="{ item }">
								<span v-if="Number(item.priceUAH)">{{ parseInt(item.priceUAH) | toMoney }}</span>
							</template>
							<template v-slot:item.priceUSD="{ item }">
								<span v-if="Number(item.priceUSD)">{{ parseInt(item.priceUSD) | toMoney }}</span>
							</template>

							<template v-slot:item.actions="{ item }">
								<v-btn icon color="blue" :href="item.uri" target="_blank">
									<v-icon>mdi-open-in-new</v-icon>
								</v-btn>
							</template>
						</v-data-table>
					</v-card>
				</v-card-text>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
import zVehicleParameters from '@/views/forms/vehicle.parameters.showroom'
import zPdf from '@/views/pdf/VehicleAveragePriceShowroom'
import downloadExcel from "vue-json-excel";
//import zFormAveragePriceStatistic from '@/views/forms/VehicleAveragePriceStatistic'

export default {
	name: 'VehicleAveragePriceShowroom',
	mixins: [mixin],
	components: {
		zVehicleParameters,
		zPdf,
		downloadExcel,
		//zFormAveragePriceStatistic,
	},
	data: () => ({
		title: 'Ціна нового авто в салонах',
		subtitle: 'Визначення ціни нового авто за даними з салонів',
		loading: false,

		headers: [
			//{ text: 'ID', value: 'code' },
			{ text: 'Назва', value: 'name' },
			{ text: 'Ціна UAH', value: 'priceUAH' },
			{ text: 'Ціна USD', value: 'priceUSD' },
			{ text: 'Опис', value: 'description' },
			{ text: "Об'ява", value: 'actions', sortable: false },
		],

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),
	
	computed: {
		...mapGetters('VehicleAveragePriceShowroom', [ 'item' ]),

		/* ...mapGetters('VehicleEstimate', [
			'params', 'item', 'isset'
		]), */

		excelName() {
			return this.title + (this.params.number ? ' ' + this.params.number : (this.params.vin ? ' ' + this.params.vin : '') + '.' +  this.excel.type)
		},

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},
		
		estimates() {
			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		},
	},

	methods: {
		...mapActions('VehicleAveragePriceShowroom', [ 'setItem' ]),

		adverts(items) {
			const sorted = [...items].sort((a, b) => parseInt(a.price) - parseInt(b.price));
			return sorted
		},

		labels(items) {
			return items.map(element=>element.name);
		},

		onClear() {
			this.$refs.parameters.reset()
			//this.clear()
		},

		/* validate() {
			//return true
			return this.params.number 
				|| this.params.vin
				|| this.params.brand
				|| this.params.model
		}, */

		onOK() {
			//console.log(this.$options.name, 'onOK','params', this.params)

			if(this.$refs.parameters.validate()) {
				this.loading = true
				var that = this
				axios.post('/vehicle/estimate/averageprice/showroom', this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},
	},
}
</script>